import { useSignal } from '@preact/signals-react'
import { useCallback, useEffect } from 'react'
import { formatDate, getSubmit } from '@ui-seeker/utils'
import { BACKEND_APIS } from '@constants'
import { groupedExportsDateRange, isLoadingTable } from 'Pages/Admin/GroupedExports/@signals'
import { useToast } from '@hooks'

export default function useTableData(isExtra) {
	const data = useSignal([])
	const { showToast } = useToast()

	const getData = useCallback(() => {
		getSubmit(`${BACKEND_APIS.REPORT}/export-group-executions`, {
			startBookingDate: formatDate(groupedExportsDateRange.value[0], { format: 'yyyyMMdd' }),
			endBookingDate: formatDate(groupedExportsDateRange.value[1], { format: 'yyyyMMdd' }),
			executionType: isExtra ? 'execution-extras' : 'execution',
			isAdminPage: true,
		}).then(result => {
			isLoadingTable.value = false
			data.value = result
		}).catch(() => {
			showToast.error('Server Error: Could not load exported data.')
			isLoadingTable.value = false
		})
	}, [ isExtra ])

	useEffect(() => {
		if (isLoadingTable.value) getData()
	}, [ isLoadingTable.value ])


	return data.value
}